/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-22",
    versionChannel: "nightly",
    buildDate: "2025-04-22T00:06:52.459Z",
    commitHash: "afcfc7fbdf0b6f1eb1bd2cc58713e52d8f5c925a",
};
